import group from "../operations/undo_group";
import {adjustRow, adjustColumn} from "../operations/column_operations";
import {getSelectedZones} from "../helpers/column_names";
import {find} from "../helpers/array";

/* row operations */

export function insertRow(row){
	callCommand(this, "add", "row", row);
}

export function deleteRow(row){
	callCommand(this, "del", "row", row);
}

export function setRowHeight(row, height, page){
	setSize(this, "row", row, height, page);
}

/* col operations */

export function insertColumn(column){
	callCommand(this, "add", "column", column);
}

export function deleteColumn(column){
	callCommand(this, "del", "column", column);
}

export function setColumnWidth(column, width, page){
	setSize(this, "column", column, width, page);
}

/* helpers */

function getCells(view, id, group, page){
	if(id){
		if(!webix.isArray(id))
			id =  [id,id];
	}
	else if(page && page != view.getActiveSheet())
		return false;
	return id;
}

function callCommand(view, name, group, id){
	let start, end;
	id = getCells(view, id, group);
	if(id === false)
		return;
	else if(id){
		start = {[group]: id[0]};
		end = {[group]: id[1]};
	}
	view.callEvent("onCommand", [{ id: name, group }, start, end]);
}

function setSize(view, type, id, size, page){
	id = getCells(view, id, type, page);
	if(id === false)
		return;

	if(!id){
		const zones = getSelectedZones(view, type);

		if(!zones) return;

		if(zones.length == 1)
			id = [zones[0].start[type], zones[0].end[type]];
		else {
			group.set(()=>{
				zones.forEach(zone => {
					setSize(view, type, [zone.start[type], zone.end[type]], size, page);
				});
			});
			return;
		}
	}

	let sheet;
	if(page && page != view.getActiveSheet()){
		sheet = find(view._sheets, obj => obj.name == page);
		if(!sheet) return;
	}

	const grid = view.$$("cells");

	group.set(()=>{
		for (let i = id[0]; i <= id[1]; i++){
			if(size == "auto"){
				if(sheet){
					//TODO: adjust not active sheet
				}
				else
					(type == "row" ? adjustRow : adjustColumn)(i, view);
			}
			else{
				if(sheet){
					if(!sheet.content.sizes)
						sheet.content.sizes = [];
					const oldSize = find(sheet.content.sizes, arr => type == "row" ? arr[0] == i : arr[1] == i);
					if(oldSize){
						if(size == oldSize[2])
							continue;
						else
							oldSize[2] = size;
					}
					else {
						if (type == "row") {
							if (size == grid.config.columnWidth)
								continue;
						} else if (size == grid.config.rowHeight)
							continue;

						const newSize = [0, 0, size];
						newSize[type == "row" ? 0 : 1] = i;
						sheet.content.sizes.push(newSize);
					}
					view.callEvent("onAction", [type+"-resize", { [type]: i, value: size, page } ]);
				}
				else{
					size *= view._zoom;
					grid[type == "row" ? "setRowHeight" : "setColumnWidth"](i, size);
				}
			}
		}
	});
}